import { FunctionComponent } from "react";
import styled from "styled-components";
import { BodySecondary, COLORS } from "@bikdotai/bik-component-library";
import AlertTriangle from "../../icons/alertTriangle";

// TODO: set to the AI Agent block migration help doc once published.
const DEPRECATED_BLOCK_LEARN_MORE_URL = "";

const DeprecatedBlockBanner: FunctionComponent = () => {
  return (
    <Container>
      <AlertTriangle width={16} height={16} color={COLORS.content.warning} />
      <BodySecondary style={{ color: COLORS.content.warning }}>
        This block has been deprecated. Please upgrade this to an AI agent
        block.{" "}
        {DEPRECATED_BLOCK_LEARN_MORE_URL && (
          <a
            rel="noreferrer"
            href={DEPRECATED_BLOCK_LEARN_MORE_URL}
            target="_blank"
          >
            Learn more
          </a>
        )}
      </BodySecondary>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px 16px;
  background-color: ${COLORS.background.warning.light};
  border-top: 1px solid ${COLORS.stroke.warning.lightAlt};

  svg {
    flex-shrink: 0;
    margin-top: 2px;
  }

  a {
    color: ${COLORS.content.brand};
    cursor: pointer;
  }
`;

export default DeprecatedBlockBanner;
